import { IS_DEVELOPMENT } from 'settings';

declare global {
  interface Window {
    pendo: any;
  }
}

type PendoAccount = {
  id: number;
  fullName: string;
  email: string;
  type: string;
  belt: string;
  alreadyTransfered: boolean;
};

type PendoVisitor = {
  id: number;
  fullName: string;
  email: string;
};

export type PendoConfig = {
  account: PendoAccount;
  visitor: PendoVisitor;
};

export function initializePendo(account: PendoAccount, visitor: PendoVisitor) {
  if (!window.pendo || IS_DEVELOPMENT) return;
  window.pendo.initialize({ account, visitor });
}
